module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cb-placeholder",
    class: _vm.deriveClass
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-132cf92c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/collections/elements/Placeholder.vue
// module id = 169
// module chunks = 65 66 68